// extracted by mini-css-extract-plugin
module.exports = {"SrInstructionsTile":"SrInstructionsTile--SrInstructionsTile--btehR","highlightYellowFadeIn":"SrInstructionsTile--highlightYellowFadeIn--xgSQw"};